<div class="auth-main">
  <div class="auth-wrapper version-2">
    <div class="auth-side-content">
      <div style="background-image: url('assets/images/hotel.jpg')" alt="images" class="img-fluid img-auth-side"></div>
    </div>
    <div class="auth-form">
      <app-card [showHeader]="false" class="auth-form-card" padding="40">
        <h4 class="text-center m-b-25 f-w-500">Authentication</h4>
        <div class="text-start">
          <label for="name" class="f-w-500">Email</label>
          <mat-form-field appearance="outline" class="w-100 m-t-5">
            <input matInput [formControl]="email" required [(ngModel)]="Email" />
            <mat-error *ngIf="email.invalid">{{ getErrorMessage() }}</mat-error>
          </mat-form-field>
          <label for="name" class="f-w-500">Password</label>
          <mat-form-field appearance="outline" class="w-100 m-t-5">
            <input matInput [type]="hide ? 'password' : 'text'" [(ngModel)]="password" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="grid">
          <button mat-flat-button color="primary" class="b-rad-20 m-t-20" (click)="login()">Login</button>
        </div>
      </app-card>
    </div>
  </div>
</div>
